import dayjs from 'dayjs';

/* "Active now", or how long ago they were last here.

   Presence is only worth showing if it is readable at a glance, so this
   deliberately stops at a date once it is old enough that an exact time no
   longer tells anyone anything useful. */
export const lastActiveLabel = (online, lastSeen) => {
    if (online) return 'Active now';
    if (!lastSeen) return 'Offline';

    const seen = dayjs(lastSeen);
    if (!seen.isValid()) return 'Offline';

    const minutes = dayjs().diff(seen, 'minute');
    if (minutes < 1) return 'Active moments ago';
    if (minutes < 60) return `Active ${minutes}m ago`;

    const hours = dayjs().diff(seen, 'hour');
    if (hours < 24 && dayjs().isSame(seen, 'day')) return `Active ${hours}h ago`;
    if (dayjs().subtract(1, 'day').isSame(seen, 'day')) return `Active yesterday ${seen.format('h:mm A')}`;
    if (dayjs().diff(seen, 'day') < 7) return `Active ${seen.format('ddd h:mm A')}`;
    return `Active ${seen.format('D MMM')}`;
};

/* The time under a message bubble. */
export const messageTime = (value) => {
    const at = dayjs(value);
    return at.isValid() ? at.format('h:mm A') : '';
};

/* The separator between days in a thread. */
export const dayLabel = (value) => {
    const at = dayjs(value);
    if (!at.isValid()) return '';
    if (at.isSame(dayjs(), 'day')) return 'Today';
    if (at.isSame(dayjs().subtract(1, 'day'), 'day')) return 'Yesterday';
    if (at.isSame(dayjs(), 'year')) return at.format('ddd, D MMM');
    return at.format('D MMM YYYY');
};

/* The time beside a row in the conversation list — compact, so it stays on
   one line next to a name. */
export const listTime = (value) => {
    const at = dayjs(value);
    if (!at.isValid()) return '';
    if (at.isSame(dayjs(), 'day')) return at.format('h:mm A');
    if (at.isSame(dayjs().subtract(1, 'day'), 'day')) return 'Yesterday';
    if (at.isSame(dayjs(), 'year')) return at.format('D MMM');
    return at.format('D MMM YY');
};
